import { Container } from 'inversify';
import 'reflect-metadata';

const container = new Container({
    // this can be removed if RouterWrapper constructor takes any arguments
    skipBaseClassChecks: true,
});

export default container;
